import { injectToolCSS } from '../utils/cssGenerator'
import { ALL_ELEMENT_SELECTORS } from '../enum/Selectors'
import ToolConfig from '../types/ToolConfig'

export const adjustLetterSpacingConfig: ToolConfig = {
  id: 'letter-spacing',
  selector: `html`,
  childrenSelector: ALL_ELEMENT_SELECTORS,
  styles: {
    'letter-spacing': '2px',
  },
}

export default function adjustLetterSpacing(enable = false) {
  injectToolCSS({
    ...adjustLetterSpacingConfig,
    enable,
  })
}
